import {
  TableIcon,
  ActivityIcon,
  FinanceIcon,
  HealthIcon,
  WorkIcon,
  FoodIcon,
  ChartIcon,
  FolderIcon,
} from "./icons";
export const datasetIcons = [
  { id: "table", label: "Tabel", component: TableIcon },
  { id: "activity", label: "Aktivitet", component: ActivityIcon },
  { id: "finance", label: "Økonomi", component: FinanceIcon },
  { id: "health", label: "Sundhed", component: HealthIcon },
  { id: "work", label: "Arbejde", component: WorkIcon },
  { id: "food", label: "Mad", component: FoodIcon },
  { id: "chart", label: "Resultater", component: ChartIcon },
  { id: "folder", label: "Samling", component: FolderIcon },
];
